import { head, pipe, pick } from '@fxts/core';
import { StockType } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/constants.ts';

export const assignStoresProduct = (stores_product) => {
  // stores_delivery_companies_products가 존재하면 새로운 에디터에서 보낸 요청
  if (stores_product._.product._.stores_delivery_companies_products) {
    // 레거시 데이터 구조에 맞춰준다.
    stores_product._.product._.stores_delivery_companies_product = pipe(
      stores_product?._?.product?._?.stores_delivery_companies_products || [],
      head,
      (stores_delivery_companies_product) =>
        pick(['stores_delivery_company_id'], stores_delivery_companies_product || {}),
    );

    // 총 수량 관리는 spo._.spo_item_stock를 바라봄
    if (stores_product._.product._.spo.stock_type === StockType.TOTAL_STOCK) {
      stores_product._.product._.spo._ = {
        ...stores_product._.product._.spo._,
        spo_item_stock: pipe(
          stores_product?._?.product?._?.spo?._?.spo_items || [],
          head,
          (spo_item) =>
            spo_item?._?.spo_item_stock || {
              plus_minus_quantity: 0,
              quantity: 0,
              real_quantity: 0,
            },
        ),

        no_option_sku: pipe(stores_product?._?.product?._?.spo?._?.spo_items || [], head, (spo_item) => ({
          nickname: '',
          ...(spo_item?._?.sku || {}),
          ...(spo_item?._?.sku?.width
            ? {
                size: {
                  ...spo_item?._?.sku,
                },
              }
            : {}),
        })),
      };
    }
  }

  return stores_product;
};
